import { bffAuthClient } from '../../api/bffAuthClient'
import type {
    AuthenticatedResponse,
    LoginMfaChallengeRequest,
    MfaAssociateResponse,
    MfaVerifyRequest,
    MfaVerifyResponse,
} from '@six-invest/api-types/auth/types'

export const bffMfaApi = {
    async associate(): Promise<MfaAssociateResponse> {
        const { data } = await bffAuthClient.post<MfaAssociateResponse>('/auth/mfa/associate')
        return data
    },
    async verify(request: MfaVerifyRequest): Promise<MfaVerifyResponse> {
        const { data } = await bffAuthClient.post<MfaVerifyResponse>('/auth/mfa/verify', request)
        return data
    },
    async challenge(request: LoginMfaChallengeRequest): Promise<AuthenticatedResponse> {
        const { data } = await bffAuthClient.post<AuthenticatedResponse>('/auth/login/mfa-challenge', request)
        return data
    },
}
